// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import {
  EBlockName,
  EButtonName,
  TButton,
} from '@/_components/promo-zone/_types';
import { Button } from '@/_kit/button';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'CardButton';

type TProps = {
  blockName: EBlockName;
  buttonProps: TButton;
  onClick: () => void;
};

export const CardButton = ({
  buttonProps: { title },
  blockName,
  onClick,
}: TProps) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const handleButtonClick = useCallback(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_PROMO_T,
      params: {
        button_name: EButtonName.MORE_DETAILS,
        name_block: blockName,
        name_subblock: '',
      },
    };

    sendEvent(config);

    onClick();
  }, [blockName, onClick, sendEvent]);

  return (
    <div className={cn(BLOCK_NAME)}>
      <Button
        backgroundColor={EButtonColor.WHITE}
        onClick={handleButtonClick}
        size={EButtonSize.MEDIUM}
        strokeColor={EButtonColor.BLACK}
      >
        <Text
          size={ETextSize.SMALL}
          text={translations(title)}
          variant="body"
        />
      </Button>
    </div>
  );
};
